import memoize from 'transmute/memoize';
import { PlayerStatuses } from '../stores/AudioPlaybackStore';
import { MEDIA_BUFFER_STATUSES } from '../constants/MediaBufferStatus';
export const INITIAL_MEDIA_PLAYBACK_STATE = {
  bufferStatus: MEDIA_BUFFER_STATUSES.INITIAL,
  clipEndTime: null,
  clipStartTime: 0,
  currentTime: 0,
  errorType: null,
  maybeRequiresAuthUpdate: false,
  percentLoaded: 0,
  playbackRequested: false,
  preciseDuration: 0,
  refetchedMediaUrl: false,
  roundedDuration: 0,
  status: PlayerStatuses.LOADING
};
export const setInitialRoundedDuration = (audioDurationInSeconds = 0) => audioDurationInSeconds ? Math.floor(audioDurationInSeconds - 0.25) : 0;
export const getInitialMediaPlaybackState = memoize((audioDurationInSeconds, initialClipEndTime, initialClipStartTime) => Object.assign({}, INITIAL_MEDIA_PLAYBACK_STATE, {
  clipEndTime: initialClipEndTime !== null && initialClipEndTime !== void 0 ? initialClipEndTime : null,
  clipStartTime: initialClipStartTime,
  preciseDuration: setInitialRoundedDuration(audioDurationInSeconds),
  roundedDuration: setInitialRoundedDuration(audioDurationInSeconds),
  status: PlayerStatuses.LOADING
}));